// RGB color type

export type RGBColor = {
  a: number // alpha (0-1)
  b: number // blue (0-1)
  g: number // green (0-1)
  r: number // red (0-1)
}
